import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import Logo from './components/Logo';
import HeaderNav from './components/HeaderNav';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';
import MediaBorders from 'constants/media-borders';
import { throttle } from 'lodash';

class Header extends React.Component {
  constructor() {
    super();

    this.scrollEvent = throttle(event => this.watchCurrentPosition(), 100);
    this.state = {
      currentPosition: 0
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  watchCurrentPosition() {
    this.setState({ currentPosition: this.scrollTop() });
  }

  scrollTop() {
    return Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
  }

  displayNav = location => !location.pathname.includes('/order-aggregators');

  render() {
    const { className, location, closeAlert } = this.props;

    return (
      <header
        className={`${
          this.state.currentPosition === 0 ? 'scroll-top' : ''
        } ${className}`}
      >
        <div className="header-content">
          <Logo />
          {this.displayNav(location) && (
            <HeaderNav location={location} closeAlert={closeAlert} />
          )}
        </div>
      </header>
    );
  }
}

const commonStyle = css`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 10;
  width: 100%;
  max-width: 1366px;
  color: ${Colors.gray1};
  background-color: ${Colors.white1};
  margin: 0 auto;
  border-bottom: solid 1px ${Colors.gray2};

  &.scroll-top {
    border-bottom: solid 1px ${Colors.white1};
  }

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    max-width: ${MediaBorders.large};
    margin: 0 auto;
    position: relative;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  height: 104px;
  padding: 0 80px;
  max-width: 100%;
`;

const spStyle = CustomMedia.lessThan('medium')`
  height: 56px;
  padding: 0 16px;
`;

export default applyStyles(Header)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/Header/index.js